module.exports = __webpack_public_path__ + "static/bgSmartphone-min-d5e74f4ab240511669d0f590766e478b.jpg";